// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "./Utilities/ErrorUtils.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "./DefaultTheme.bs.js";
import * as EnglishLocale$OrcaPaymentPage from "./LocaleStrings/EnglishLocale.bs.js";
import * as ConstantStrings$OrcaPaymentPage from "./LocaleStrings/ConstantStrings.bs.js";
import * as LocaleStringHelper$OrcaPaymentPage from "./LocaleStrings/LocaleStringHelper.bs.js";

function getTheme(val) {
  var str = val.toLowerCase();
  switch (str) {
    case "brutal" :
        return "Brutal";
    case "bubblegum" :
        return "Bubblegum";
    case "charcoal" :
        return "Charcoal";
    case "default" :
        return "Default";
    case "midnight" :
        return "Midnight";
    case "none" :
        return "NONE";
    case "soft" :
        return "Soft";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "default",
            "midnight",
            "brutal",
            "charcoal",
            "soft",
            "bubblegum",
            "none"
          ], "appearance.theme");
      return "Default";
  }
}

function getInnerLayout(str) {
  if (str === "compressed") {
    return "Compressed";
  } else {
    return "Spaced";
  }
}

function getColorScheme(str) {
  var str$1 = str.toLowerCase();
  switch (str$1) {
    case "auto" :
        return "Auto";
    case "dark" :
        return "Dark";
    case "light" :
        return "Light";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str$1, [
            "light",
            "dark",
            "auto"
          ], "appearance.colorScheme");
      return "Light";
  }
}

function setColorSchemeMeta(colorScheme) {
  var el = document.querySelector("meta[name=\"color-scheme\"]");
  var meta;
  if (el == null) {
    var el$1 = document.createElement("meta");
    el$1.setAttribute("name", "color-scheme");
    document.head.appendChild(el$1);
    meta = el$1;
  } else {
    meta = el;
  }
  var colorSchemeVal;
  switch (colorScheme) {
    case "Light" :
        colorSchemeVal = "light";
        break;
    case "Auto" :
        colorSchemeVal = "light dark";
        break;
    case "Dark" :
        colorSchemeVal = "dark";
        break;
    
  }
  meta.setAttribute("content", colorSchemeVal);
}

function getShowLoader(str) {
  switch (str) {
    case "always" :
        return "Always";
    case "auto" :
        return "Auto";
    case "never" :
        return "Never";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "auto",
            "always",
            "never"
          ], "loader");
      return "Auto";
  }
}

var defaultAppearance_rules = {};

var defaultAppearance = {
  theme: "Default",
  componentType: "payment",
  variables: DefaultTheme$OrcaPaymentPage.default,
  rules: defaultAppearance_rules,
  labels: "Above",
  innerLayout: "Spaced",
  colorScheme: "Light"
};

var defaultConfig_fonts = [];

var defaultConfig = {
  appearance: defaultAppearance,
  locale: "auto",
  pmSessionId: "",
  clientSecret: "",
  fonts: defaultConfig_fonts,
  loader: "Auto",
  sdkAuthorization: ""
};

async function getLocaleObject(string) {
  try {
    var locale = string === "auto" ? window.navigator.language : string;
    var match = LocaleStringHelper$OrcaPaymentPage.mapLocalStringToTypeLocale(locale);
    var tmp;
    switch (match) {
      case "EN" :
          tmp = import("./LocaleStrings/EnglishLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "HE" :
          tmp = import("./LocaleStrings/HebrewLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "FR" :
          tmp = import("./LocaleStrings/FrenchLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "EN_GB" :
          tmp = import("./LocaleStrings/EnglishGBLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "AR" :
          tmp = import("./LocaleStrings/ArabicLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "JA" :
          tmp = import("./LocaleStrings/JapaneseLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "DE" :
          tmp = import("./LocaleStrings/DeutschLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "FR_BE" :
          tmp = import("./LocaleStrings/FrenchBelgiumLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "ES" :
          tmp = import("./LocaleStrings/SpanishLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "CA" :
          tmp = import("./LocaleStrings/CatalanLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "PT" :
          tmp = import("./LocaleStrings/PortugueseLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "IT" :
          tmp = import("./LocaleStrings/ItalianLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "PL" :
          tmp = import("./LocaleStrings/PolishLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "NL" :
          tmp = import("./LocaleStrings/DutchLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "SV" :
          tmp = import("./LocaleStrings/SwedishLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "RU" :
          tmp = import("./LocaleStrings/RussianLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "ZH" :
          tmp = import("./LocaleStrings/ChineseLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      case "ZH_HANT" :
          tmp = import("./LocaleStrings/TraditionalChineseLocale.bs.js").then(function (m) {
                return m.localeStrings;
              });
          break;
      
    }
    return await tmp;
  }
  catch (exn){
    return EnglishLocale$OrcaPaymentPage.localeStrings;
  }
}

async function getConstantStringsObject() {
  try {
    return await import("./LocaleStrings/ConstantStrings.bs.js").then(function (m) {
                return m.constantStrings;
              });
  }
  catch (exn){
    return ConstantStrings$OrcaPaymentPage.constantStrings;
  }
}

var defaultRecoilConfig = {
  config: defaultConfig,
  themeObj: DefaultTheme$OrcaPaymentPage.default,
  localeString: EnglishLocale$OrcaPaymentPage.localeStrings,
  constantString: ConstantStrings$OrcaPaymentPage.constantStrings,
  showLoader: false
};

function getVariables(str, dict, $$default, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    var validKeys = [
                      "fontFamily",
                      "fontSizeBase",
                      "colorPrimary",
                      "colorBackground",
                      "colorText",
                      "colorDanger",
                      "colorDangerText",
                      "borderRadius",
                      "fontVariantLigatures",
                      "fontVariationSettings",
                      "spacingUnit",
                      "fontWeightLight",
                      "fontWeightNormal",
                      "fontWeightMedium",
                      "fontWeightBold",
                      "fontLineHeight",
                      "fontSizeXl",
                      "fontSizeLg",
                      "fontSizeSm",
                      "fontSizeXs",
                      "fontSize2Xs",
                      "fontSize3Xs",
                      "colorSuccess",
                      "colorWarning",
                      "colorPrimaryText",
                      "colorBackgroundText",
                      "colorSuccessText",
                      "colorWarningText",
                      "colorTextSecondary",
                      "colorTextPlaceholder",
                      "spacingTab",
                      "borderColor",
                      "spacingGridColumn",
                      "spacingGridRow",
                      "spacingAccordionItem",
                      "buttonBackgroundColor",
                      "buttonHeight",
                      "buttonWidth",
                      "buttonBorderRadius",
                      "buttonBorderColor",
                      "buttonTextColor",
                      "buttonTextFontSize",
                      "buttonTextFontWeight",
                      "buttonBorderWidth"
                    ];
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning(validKeys, json, "appearance.variables");
                    return {
                            fontFamily: Utils$OrcaPaymentPage.getWarningString(json, "fontFamily", $$default.fontFamily, logger),
                            fontSizeBase: Utils$OrcaPaymentPage.getWarningString(json, "fontSizeBase", $$default.fontSizeBase, logger),
                            colorPrimary: Utils$OrcaPaymentPage.getWarningString(json, "colorPrimary", $$default.colorPrimary, logger),
                            colorBackground: Utils$OrcaPaymentPage.getWarningString(json, "colorBackground", $$default.colorBackground, logger),
                            colorText: Utils$OrcaPaymentPage.getWarningString(json, "colorText", $$default.colorText, logger),
                            colorDanger: Utils$OrcaPaymentPage.getWarningString(json, "colorDanger", $$default.colorDanger, logger),
                            borderRadius: Utils$OrcaPaymentPage.getWarningString(json, "borderRadius", $$default.borderRadius, logger),
                            fontVariantLigatures: Utils$OrcaPaymentPage.getWarningString(json, "fontVariantLigatures", $$default.fontVariantLigatures, logger),
                            fontVariationSettings: Utils$OrcaPaymentPage.getWarningString(json, "fontVariationSettings", $$default.fontVariationSettings, logger),
                            spacingUnit: Utils$OrcaPaymentPage.getWarningString(json, "spacingUnit", $$default.spacingUnit, logger),
                            fontWeightLight: Utils$OrcaPaymentPage.getWarningString(json, "fontWeightLight", $$default.fontWeightLight, logger),
                            fontWeightNormal: Utils$OrcaPaymentPage.getWarningString(json, "fontWeightNormal", $$default.fontWeightNormal, logger),
                            fontWeightMedium: Utils$OrcaPaymentPage.getWarningString(json, "fontWeightMedium", $$default.fontWeightMedium, logger),
                            fontWeightBold: Utils$OrcaPaymentPage.getWarningString(json, "fontWeightBold", $$default.fontWeightBold, logger),
                            fontLineHeight: Utils$OrcaPaymentPage.getWarningString(json, "fontLineHeight", $$default.fontLineHeight, logger),
                            fontSize2Xl: Utils$OrcaPaymentPage.getWarningString(json, "fontSize2Xl", $$default.fontSize2Xl, logger),
                            fontSizeXl: Utils$OrcaPaymentPage.getWarningString(json, "fontSizeXl", $$default.fontSizeXl, logger),
                            fontSizeLg: Utils$OrcaPaymentPage.getWarningString(json, "fontSizeLg", $$default.fontSizeLg, logger),
                            fontSizeSm: Utils$OrcaPaymentPage.getWarningString(json, "fontSizeSm", $$default.fontSizeSm, logger),
                            fontSizeXs: Utils$OrcaPaymentPage.getWarningString(json, "fontSizeXs", $$default.fontSizeXs, logger),
                            fontSize2Xs: Utils$OrcaPaymentPage.getWarningString(json, "fontSize2Xs", $$default.fontSize2Xs, logger),
                            fontSize3Xs: Utils$OrcaPaymentPage.getWarningString(json, "fontSize3Xs", $$default.fontSize3Xs, logger),
                            colorSuccess: Utils$OrcaPaymentPage.getWarningString(json, "colorSuccess", $$default.colorSuccess, logger),
                            colorWarning: Utils$OrcaPaymentPage.getWarningString(json, "colorWarning", $$default.colorWarning, logger),
                            colorPrimaryText: Utils$OrcaPaymentPage.getWarningString(json, "colorPrimaryText", $$default.colorPrimaryText, logger),
                            colorBackgroundText: Utils$OrcaPaymentPage.getWarningString(json, "colorBackgroundText", $$default.colorBackgroundText, logger),
                            colorSuccessText: Utils$OrcaPaymentPage.getWarningString(json, "colorSuccessText", $$default.colorSuccessText, logger),
                            colorDangerText: Utils$OrcaPaymentPage.getWarningString(json, "colorDangerText", $$default.colorDangerText, logger),
                            colorWarningText: Utils$OrcaPaymentPage.getWarningString(json, "colorWarningText", $$default.colorWarningText, logger),
                            colorTextSecondary: Utils$OrcaPaymentPage.getWarningString(json, "colorTextSecondary", $$default.colorTextSecondary, logger),
                            colorTextPlaceholder: Utils$OrcaPaymentPage.getWarningString(json, "colorTextPlaceholder", $$default.colorTextPlaceholder, logger),
                            spacingTab: Utils$OrcaPaymentPage.getWarningString(json, "spacingTab", $$default.spacingTab, logger),
                            borderColor: Utils$OrcaPaymentPage.getWarningString(json, "borderColor", $$default.borderColor, logger),
                            spacingAccordionItem: Utils$OrcaPaymentPage.getWarningString(json, "spacingAccordionItem", $$default.spacingAccordionItem, logger),
                            colorIconCardCvc: Utils$OrcaPaymentPage.getWarningString(json, "colorIconCardCvc", $$default.colorIconCardCvc, logger),
                            colorIconCardCvcError: Utils$OrcaPaymentPage.getWarningString(json, "colorIconCardCvcError", $$default.colorIconCardCvcError, logger),
                            colorIconCardError: Utils$OrcaPaymentPage.getWarningString(json, "colorIconCardError", $$default.colorIconCardError, logger),
                            spacingGridColumn: Utils$OrcaPaymentPage.getWarningString(json, "spacingGridColumn", $$default.spacingGridColumn, logger),
                            spacingGridRow: Utils$OrcaPaymentPage.getWarningString(json, "spacingGridRow", $$default.spacingGridRow, logger),
                            buttonBackgroundColor: Utils$OrcaPaymentPage.getWarningString(json, "buttonBackgroundColor", $$default.buttonBackgroundColor, logger),
                            buttonHeight: Utils$OrcaPaymentPage.getWarningString(json, "buttonHeight", $$default.buttonHeight, logger),
                            buttonWidth: Utils$OrcaPaymentPage.getWarningString(json, "buttonWidth", $$default.buttonWidth, logger),
                            buttonBorderRadius: Utils$OrcaPaymentPage.getWarningString(json, "buttonBorderRadius", $$default.buttonBorderRadius, logger),
                            buttonBorderColor: Utils$OrcaPaymentPage.getWarningString(json, "buttonBorderColor", $$default.buttonBorderColor, logger),
                            buttonTextColor: Utils$OrcaPaymentPage.getWarningString(json, "buttonTextColor", $$default.buttonTextColor, logger),
                            buttonTextFontSize: Utils$OrcaPaymentPage.getWarningString(json, "buttonTextFontSize", $$default.buttonTextFontSize, logger),
                            buttonTextFontWeight: Utils$OrcaPaymentPage.getWarningString(json, "buttonTextFontWeight", $$default.buttonTextFontWeight, logger),
                            buttonBorderWidth: Utils$OrcaPaymentPage.getWarningString(json, "buttonBorderWidth", $$default.buttonBorderWidth, logger),
                            disabledFieldColor: Utils$OrcaPaymentPage.getWarningString(json, "disabledFieldColor", $$default.disabledFieldColor, logger)
                          };
                  })), $$default);
}

function getAppearance(str, dict, $$default, defaultRules, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "theme",
                          "variables",
                          "rules",
                          "labels",
                          "innerLayout",
                          "colorScheme"
                        ], json, "appearance");
                    var rulesJson = defaultRules(getVariables("variables", json, $$default, logger));
                    var str = Utils$OrcaPaymentPage.getWarningString(json, "labels", "above", logger).toLowerCase();
                    var tmp;
                    switch (str) {
                      case "above" :
                          tmp = "Above";
                          break;
                      case "floating" :
                          tmp = "Floating";
                          break;
                      case "none" :
                          tmp = "Never";
                          break;
                      default:
                        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
                              "above",
                              "floating",
                              "never"
                            ], "appearance.labels");
                        tmp = "Above";
                    }
                    return {
                            theme: getTheme(Utils$OrcaPaymentPage.getWarningString(json, "theme", "default", logger)),
                            componentType: Utils$OrcaPaymentPage.getWarningString(json, "componentType", "", logger),
                            variables: getVariables("variables", json, $$default, logger),
                            rules: Utils$OrcaPaymentPage.mergeJsons(rulesJson, Utils$OrcaPaymentPage.getJsonObjectFromDict(json, "rules")),
                            labels: tmp,
                            innerLayout: getInnerLayout(Utils$OrcaPaymentPage.getWarningString(json, "innerLayout", "spaced", logger)),
                            colorScheme: getColorScheme(Utils$OrcaPaymentPage.getWarningString(json, "colorScheme", "light", logger))
                          };
                  })), defaultAppearance);
}

function getFonts(str, dict, logger) {
  return Belt_Array.keepMap(Core__Option.getOr(Core__Option.flatMap(dict[str], Core__JSON.Decode.array), []), Core__JSON.Decode.object).map(function (json) {
              ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                    "cssSrc",
                    "family",
                    "src",
                    "weight"
                  ], json, "fonts");
              return {
                      cssSrc: Utils$OrcaPaymentPage.getWarningString(json, "cssSrc", "", logger),
                      family: Utils$OrcaPaymentPage.getWarningString(json, "family", "", logger),
                      src: Utils$OrcaPaymentPage.getWarningString(json, "src", "", logger),
                      weight: Utils$OrcaPaymentPage.getWarningString(json, "weight", "", logger)
                    };
            });
}

function itemToObjMapper(dict, $$default, defaultRules, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "appearance",
        "fonts",
        "locale",
        "clientSecret",
        "loader",
        "pmSessionId",
        "sdkAuthorization"
      ], dict, "elements");
  return {
          appearance: getAppearance("appearance", dict, $$default, defaultRules, logger),
          locale: Utils$OrcaPaymentPage.getWarningString(dict, "locale", "auto", logger),
          pmSessionId: Utils$OrcaPaymentPage.getWarningString(dict, "pmSessionId", "", logger),
          clientSecret: Utils$OrcaPaymentPage.getWarningString(dict, "clientSecret", "", logger),
          fonts: getFonts("fonts", dict, logger),
          loader: getShowLoader(Utils$OrcaPaymentPage.getWarningString(dict, "loader", "auto", logger)),
          sdkAuthorization: Utils$OrcaPaymentPage.getString(dict, "sdkAuthorization", "")
        };
}

var defaultFonts = {
  cssSrc: "",
  family: "",
  src: "",
  weight: ""
};

export {
  getTheme ,
  getInnerLayout ,
  getColorScheme ,
  setColorSchemeMeta ,
  getShowLoader ,
  defaultAppearance ,
  defaultFonts ,
  defaultConfig ,
  getLocaleObject ,
  getConstantStringsObject ,
  defaultRecoilConfig ,
  getVariables ,
  getAppearance ,
  getFonts ,
  itemToObjMapper ,
}
/* Utils-OrcaPaymentPage Not a pure module */
